import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowsWidthRegular from './arrows-width-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ArrowsWidthRegular {...props} />;
}
SvgComponent.iconName = 'arrowsWidthRegular';

export const ArrowsWidthRegularIcon = svgIconWrapper(SvgComponent);
